<template>
  <div>
    <div class="my_evaluation_box">
      <div class="my_evaluation_item">
        <!-- <h2 class="clearfix_"><span class="fl">订单编号：</span><em class="fl">123456</em><span class="fl">下单时间：</span><em class="fl">123456</em></h2> -->
        <ul>
          <li v-for="(item,index) in evaluationList" :key="index" class="clearfix_">
            <div class="fl my_evaluation_goods">
              <p class="my_evaluation_goods_pic"><img :src="item.goodsPic" alt=""></p>
              <p class="my_evaluation_goods_name">{{item.goodsName}}</p>
              <!-- <p class="my_evaluation_goods_name">{{item.unitName}};{{item.property1}}</p> -->
              <p style="margin-top:10px;" class="my_evaluation_goods_price">{{item.unitName}};{{item.property1}}</p>
              <p style="margin-top:10px;" class="my_evaluation_goods_price">¥{{item.salesMoney}}</p>
            </div>
            <div class="fl my_evaluation_goods_evaluation">
              <div class="my_evaluation_goods_evaluation_bg">
                <div class="my_evaluation_goods_evaluation_star">
                  <img v-for="(val,idx) in starList" v-show="item.level>idx" :key="idx" :src="star1" alt="">
                </div>
                <div class="my_evaluation_goods_evaluation_txt">
                  <p>我的心得：{{item.evalua}}</p>
                  <!-- <p class="p1">我的心得：{{item.evalua}}</p> -->
                </div>
                <div class="my_evaluation_goods_evaluation_img clearfix_">
                  <div class="my_evaluation_goods_evaluation_img_item fl" v-show="val" v-for="(val,idx) in item.pic" :key="idx"><img :src="val" alt=""></div>
                </div>
              </div>
            </div>
            <div class="fl my_evaluation_goods_btn">
              <p v-show="item.status==1"><span><router-link tag="a" :to="{name:'evaluateOrder',query: {id:item.orderId,isAppend:1}}">追加评价</router-link></span></p>
              <p v-show="item.status==2"><span>已追评</span></p>
            </div>
          </li>
          <li v-show="noData" class="no_data">暂无评价!</li>
        </ul>
      </div>
      <div v-show="total" class="my_evaluation_pages">
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="evaluationPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      star1:require('../../assets/img/star_1.png'),
      starList:[{id:1,isChecked:true},{id:2,isChecked:true},{id:3,isChecked:true},{id:4,isChecked:true},{id:5,isChecked:true}],
      evaluationList:[],
      evaluationPage:1,
      total:0,
      noData:false
    }
  },
  mounted:function(){
    var t_=this
    t_.getEvaluation(t_.evaluationPage)
  },
  methods:{
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.evaluationPage=val
      this.evaluationList=[]
      this.getEvaluation(val)
    },
    getEvaluation:function(page){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        page:page,
        pagesize:10
      })
      axios.post(`${ip}formWorkInterface/evaluationByMemberId`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.rows.length==0){
            t_.noData=true
          }else{
            t_.noData=false
            t_.total=res.data.total
            t_.evaluationList=res.data.rows
          }
        }
      })
    }
  }
}
</script>
<style>
  .my_evaluation_box{
    width: 1068px;
    border: 1px solid #ddd;
    background: #fff;
  }
  .my_evaluation_item h2{
    width: 1068px;
    height: 36px;
    background: #f8f8f8;
    border-bottom: 1px solid #ddd;
    line-height: 36px;
    color: #333;
  }
  .my_evaluation_item h2 span{
    margin-left: 20px;
    color:#999;
  }
  .my_evaluation_item li{
    border-bottom: 1px solid #ddd;
  }
  .my_evaluation_item li:last-child{
    border-bottom:0;
  }
  .my_evaluation_goods{
    padding: 20px;
    height: 215px;
    width: 102px;
    border-right: 1px solid #ddd;
  }
  .my_evaluation_goods_pic{
    width: 100px;
    height: 100px;
    border: 1px solid #ddd;
    margin-bottom: 3px;
  }
  .my_evaluation_goods_pic img{
    width: 100px;
    height: 100px;
  }
  .my_evaluation_goods_name{
    width: 102px;
    line-height: 20px;
    color:#666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .my_evaluation_goods_price{
    color:#333;
  }
  .my_evaluation_goods_evaluation{
    width: 736px;
    padding: 20px;
    border-right: 1px solid #ddd;
    height: 215px;
  }
  .my_evaluation_goods_evaluation_bg{
    width: 712px;
    height: 165px;
    background: #f6fafe;
    border-radius: 15px;
    padding: 30px 12px 0 12px;
  }
  .my_evaluation_goods_evaluation_star{
    margin-bottom: 10px;
  }
  .my_evaluation_goods_evaluation_txt{
    margin-bottom: 12px;
    height: 50px;
  }
  .my_evaluation_goods_evaluation_txt p{
    width: 712px;
    line-height: 20px;
    height: 60px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .my_evaluation_goods_evaluation_txt .p1{
    -webkit-line-clamp: 1;
  }
  .my_evaluation_goods_evaluation_img_item{
    width: 60px;
    height: 60px;
    border: 1px solid #ddd;
    margin-right: 15px;
  }
  .my_evaluation_goods_evaluation_img_item img{
    width: 60px;
    height: 60px;
  }
  .my_evaluation_goods_btn{
    padding-top: 110px;
    width: 148px;
  }
  .my_evaluation_goods_btn p{
    text-align: center;
  }
  .my_evaluation_goods_btn span{
    cursor: pointer;
  }
  .no_data{
    height: 36px;
    line-height: 36px;
    text-align: center;
  }
  .my_evaluation_pages{    
    border-top: 1px solid #ddd;
    padding-top: 10px;
    margin-bottom: 10px;
    text-align: center;
  }
  .my_evaluation_pages .el-pagination__jump{
    margin-top:-9px;
  }
  .my_evaluation_pages .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/my_evaluation.vue